import { render, staticRenderFns } from "./standard2.vue?vue&type=template&id=78d0138e&"
import script from "./standard2.vue?vue&type=script&lang=js&"
export * from "./standard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports